module.exports    = {
	"language": "语言",
	"hello": "世界 {{.a}}",
	"c001": "网络错误，请稍候再试！",
	"c002": "退出",
	"c003": "登录",
	"c004": "请输入用户名",
	"c005": "请输入登录密码",
	"c006": "保存",
	"c007": "您填写的帐号或密码不正确",
	"c008": "帐号",
	"c009": "语言",
	"c010": "共",
	"c011": "条",
	"c012": "您好,",
	"c013": "您的帐号未激活，请与管理员联系",
	"c014": "您的账号已被冻结，请与管理员联系",
	"c015": "复位",
	"c016": "websocket连接失败",
	"c017": "内部错误",
	"c018": "您没有权限进行此操作",
	"c019": "当前用户没有权限查看本页面",
	"c020": "登录信息已失效，请重新登录！",
	"c021": "用户登录",
	"c022": "文档",
	"c023": "合格",
	"c024": "不良",
	"c025": "结果",
	"c026": "系统",
	"c027": "数据库连接异常，请检查。",
	"c028": "数据库初始化异常，请检查",
	"m001": "脱机",
	"m002": "联机",
	"m003": "异常",
	"m004": "已删除",
	"m005": "添加设备",
	"m006": "编辑设备",
	"m007": "设备管理",
	"m008": "编号",
	"m009": "状态",
	"m010": "设备编号",
	"m011": "设备名称",
	"m012": "所属区域",
	"m013": "排序",
	"m014": "IP地址",
	"m015": "通讯地址",
	"m016": "备注",
	"m017": "更新时间",
	"m018": "操作",
	"m019": "编辑",
	"m020": "编辑设备成功",
	"m021": "添加设备成功",
	"m022": "重复的设备名或设备编号或IP地址",
	"m023": "设备名称不能为空,且长度不能低于2",
	"m024": "设备编号不能为空,且长度不能低于2",
	"m025": "IP地址不能为空",
	"m026": "端口需为整数，且不能超过5位数",
	"m027": "删除",
	"m028": "恢复",
	"m029": "端口",
	"m030": "启动自动联机",
	"m031": "提示：通讯地址需与焊机编程器中一致",
	"m032": "所有区域",
	"m033": "所有状态",
	"m034": "请选择",
	"m035": "在线",
	"m036": "离线",
	"m037": "删除设备异常，请稍候再重试",
	"m038": "恢复设备异常，请稍候再重试",
	"m039": "删除设备成功",
	"m040": "恢复设备成功",
	"m041": "获取设备数据异常，请稍候再重试",
	"m042": "IP格式不对",
	"m043": "通信地址需为整数，且不能超过5位数",
	"m044": "请选择所属的区域",
	"m045": "编辑设备失败",
	"m046": "添加设备失败",
	"m047": "设备名重复，请修改",
	"m048": "设备编号重复，请修改",
	"m049": "IP地址重复，请修改",
	"m050": "采集电流曲线",
	"m051": "采集电压曲线",
	"m052": "采集电阻曲线",
	"m053": "采集压力曲线",
	"m054": "自动联机",
	"m055": "解释导入文件错误",
	"m056": "读上传文件错误",
	"m057": "文件扩展名错误（.xlsx;.xlsm;.xltx）",
	"m058": "文件过大（10M）",
	"m059": "设备",
	"m060": "字段",
	"m061": "导入完成，共导入{{.a}}条，其中新增{{.b}}条 ",
	"m062": "导入失败",
	"m063": "关闭",
	"m064": "同一规范,不允许比较",
	"m065": "查询控制器列表错误",
	"m066": "文件扩展名不允许",
	"m067": "密码不正确，请重新输入",
	"m068": "升级成功",
	"m069": "确定要恢复控制器的出厂设置？",
	"m070": "设备类型只支持803",
	"m071": "系统正在处理，请稍等",
	"m072": "添加任务成功，任务处理中",
	"m073": "导入将覆盖原有数据，确定要导入吗？",
	"m074": "文件写入异常",
	"m075": "查询设备名称/设备编号/IP地址/备注",
	"m076": "全部联机",
	"m077": "全部脱机",
	"m078": "全部联机成功",
	"m079": "全部脱机成功",
	"m080": "全部联机失败",
	"m081": "全部脱机失败",
	"m082": "无法创建excel表格",
	"m083": "焊接曲线反序列化错误",
	"m084": "获取报警记录异常",
	"m085": "写入系统参数1异常",
	"m086": "写入系统参数2异常",
	"m087": "写入系统参数3异常",
	"m088": "无法找到，请先新增对应的区域",
	"m089": "设备总数",
	"m090": "重连",
	"m091": "备份",
	"m092": "规范参数",
	"m093": "系统参数",
	"m094": "你没有选择任何设备！",
	"m095": "你没有选择备份的参数！",
	"m096": "批量备份正在进行中，请稍等",
	"m097": "备份不存在！",
	"m098": "备份打包异常！",
	"m099": "批量备份已完成，请下载",
	"m100": "创建tar文件失败",
	"m101": "获取路径失败",
	"m102": "备份成功",
	"m103": "请选择要升级的文件",
	"m104": "设备升级",
	"m105": "升级过程中发生异常",
	"m106": "固件数据为空，无法升级",
	"m107": "设备「{{.a}}」无法连接，请检查，如依然有问题，请尝试重启设备",
	"m108": "文件非升级包，请检查",
	"m109": "发送开始包失败",
	"m110": "接收开始包响应异常",
	"m111": "发送数据包时异常，包位置：",
	"m112": "接收数据包时异常，包位置：",
	"m113": "发送结束包时异常",
	"m114": "接收结束包时异常",
	"m115": "设备正在升级中，请稍等",
	"m116": "设备升级中",
	"m117": "设备升级成功",
	"m118": "设备升级失败",
	"m119": "重试",
	"m120": "等待开始",
	"m121": "升级进度总览",
	"m122": "成功：",
	"m123": "失败",
	"m124": "进行中",
	"m125": "设备升级详情",
	"m126": "由于页面经过刷新，固件文件丢失，无法重试。",
	"m127": "其它",
	"m128": "升级已取消",
	"m129": "正在取消中...",
	"m130": "取消升级后，后续的设备将停止升级，您确认要取消吗？",
	"m131": "在线设备",
	"m132": "离线设备",
	"m133": "重连设备",
	"m134": "设备名/设备编号/IP",
	"m135": "暂时没有找到相关设备",
	"m136": "当前没有设备可操作",
	"m137": "设备ID",
	"m138": "原控制器软件版本",
	"m139": "下载失败，没有找到相关数据",
	"m140": "操作结果",
	"m141": "设备类型",
	"m142": "请选择设备类型",
	"m143": "您的软件版本没有激活此设备类型，如需激活，请与厂家联系。",
	"m144": "HRC-803中频焊机",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650焊接质量监控仪",
	"m149": "HRC-670铆接质量监控仪",
	"m150": "HRC-62交流焊机",
	"m151": "当前激活码",
	"m152": "参数备份",
	"m153": "参数还原",
	"m154": "设备导入",
	"m155": "所有设备导出",
	"m156": "设备正在参数备份中，请稍等",
	"m157": "参数备份已取消",
	"m158": "无法创建备份目录，参数备份失败",
	"m159": "备份发生异常，参数备份失败",
	"m160": "无法读取规范数据，参数备份失败",
	"m161": "无法创建excel表格，参数备份失败",
	"m162": "无法读取系统参数，参数备份失败",
	"m163": "设备已脱机，参数备份失败",
	"m164": "参数备份进度总览",
	"m165": "参数备份详情",
	"m166": "设备参数备份中",
	"m167": "参数备份成功",
	"m168": "参数备份失败",
	"m169": "备份规范参数",
	"m170": "规范参数备份进度",
	"m171": "系统参数备份进度",
	"m172": "焊点信息备份进度",
	"m173": "重试升级任务已启动",
	"m174": "重试备份任务已启动",
	"m175": "取消升级任务已启动",
	"m176": "取消备份任务已启动",
	"m177": "取消备份后，后续的设备将停止备份，您确认要取消吗？",
	"m178": "请选择tar压缩文件",
	"m179": "解压文件出错，请检查文件是否正常",
	"m180": "参数还原完成",
	"m181": "参数还原过程发生异常",
	"m182": "参数还原进度总览",
	"m183": "参数还原详情",
	"m184": "设备参数还原中",
	"m185": "参数还原成功",
	"m186": "参数还原失败",
	"m187": "规范参数还原进度",
	"m188": "系统参数还原进度",
	"m189": "焊点信息还原进度",
	"m190": "焊点信息导入异常",
	"m191": "备份已取消",
	"m192": "参数还原已取消",
	"m193": "设备有备份或还原任务中，无法下载",
	"m194": "取消参数还原后，后续的还原将停止，您确认要取消吗？",
	"m195": "压缩文件中无法找到对应的设备，请检查文件",
	"m196": "重试参数还原任务已启动",
	"m197": "设备有其它任务在运行，无法操作",
	"m198": "还原参数有：",
	"m199": "由于您的激活信息没有激活任意设备类型，暂时无法添加或修改设备",
	"m200": "该设备暂不支持此操作。",
	"m201": "备份文件",
	"m202": "导入文件与设备编号或类型不符，文件名前缀格式须为：设备编号+{{.a}}",
	"m203": "登录密码",
	"m204": "请选择文件",
	"m205": "清理数据后无法恢复，确认要清理吗？",
	"m206": "清理备份",
	"m207": "清理",
	"m208": "清理成功",
	"m209": "清理失败",
	"m210": "设备mac地址冲突",
	"m211": "用户「{{.a}}」备份了设备「{{.b}}」的参数:",
	"m212": "当前设备打开，不可重复操作",
	"p001": "新建区域",
	"p002": "编辑区域",
	"p003": "区域被引用，不允许删除",
	"p004": "区域管理",
	"p005": "区域名称",
	"p006": "区域备注",
	"p007": "编辑区域成功",
	"p008": "添加区域成功",
	"p009": "重复的区域名称",
	"p010": "区域名称不能为空，且长度不能低于2",
	"p011": "排序必须为正整数，且不能超过5位数",
	"p012": "分页参数异常",
	"p013": "获取区域数据异常，请稍候再重试",
	"p014": "入参ID异常，必须为整数",
	"p015": "提交数据异常",
	"p016": "区域名称重复，请重新修改再提交",
	"p017": "添加区域异常，请稍候再重试",
	"p018": "更新区域异常，请稍候再重试",
	"p019": "检查区域是否被占用异常，请稍候再重试",
	"p020": "删除区域异常，请稍候再重试",
	"p021": "恢复区域异常，请稍候再重试",
	"p022": "删除区域成功",
	"p023": "恢复区域成功",
	"p024": "条/页",
	"p025": "修磨前规范号",
	"p026": "修磨后规范号",
	"p027": "暂无数据",
	"p028": "保存参考曲线",
	"p029": "该记录无电阻曲线数据",
	"p030": "最近三天的电阻曲线",
	"p031": "修磨前后曲线数据长度不一致，无法选择",
	"p032": "该记录没有电阻曲线",
	"p033": "选择曲线长度与当前图表长度不一致，无法选择",
	"p034": "修磨前",
	"p035": "修磨后",
	"p036": "请先选择曲线记录",
	"p037": "所选记录没有电阻曲线数据",
	"p038": "[参考曲线]修磨前",
	"p039": "[参考曲线]修磨后",
	"p040": "请先生成参考曲线",
	"p041": "保存参考曲线成功",
	"p042": "查询曲线参考记录异常",
	"p043": "曲线数据异常",
	"p044": "曲线超出保存参考曲线波动范围，无法生成",
	"p045": "实时曲线与参考曲线长度不符",
	"p046": "实时曲线不在预期参考曲线范围内",
	"p047": "修磨设置",
	"p048": "修磨设置查看",
	"p049": "修磨设置管理",
	"p050": "修磨监控",
	"p051": "修磨监控查看",
	"p052": "修磨监控管理",
	"p053": "保存参考曲线波动范围",
	"p054": "监控参考曲线波动范围",
	"p055": "告警类型",
	"p056": "查看",
	"p057": "[实时曲线]修磨前",
	"p058": "[实时曲线]修磨后",
	"p059": "当前参考电阻曲线",
	"p060": "参考电阻曲线",
	"p061": "预览电阻曲线",
	"p062": "修磨后电阻值大于修磨前电阻值",
	"u001": "用户管理",
	"u002": "新建用户",
	"u003": "姓名",
	"u004": "角色",
	"u005": "密码",
	"u006": "编辑用户",
	"u007": "查看员",
	"u008": "操作员",
	"u009": "管理员",
	"u010": "未激活",
	"u011": "正常",
	"u012": "冻结",
	"u013": "帐号名称至少三个字符",
	"u014": "姓名至少三个字符",
	"u015": "密码至少三个字符",
	"u016": "请选择角色",
	"u017": "请选择状态",
	"u018": "编辑用户成功",
	"u019": "添加用户成功",
	"u020": "获取用户数据异常，请稍候再重试",
	"u021": "删除用户成功",
	"u022": "恢复用户成功",
	"u023": "帐号名重复，请修改",
	"u024": "添加用户异常，请稍候再重试",
	"u025": "编辑用户异常，请稍候再重试",
	"u026": "删除用户异常，请稍候再重试",
	"u027": "恢复用户异常，请稍候再重试",
	"u028": "操作员ID",
	"u029": "角色管理",
	"u030": "新建角色",
	"u031": "获取角色数据异常，请稍候再重试",
	"u032": "角色名重复，请修改",
	"u033": "添加角色异常，请稍候再重试",
	"u034": "编辑角色异常，请稍候再重试",
	"u035": "删除角色异常，请稍候再重试",
	"u036": "恢复角色异常，请稍候再重试",
	"u037": "添加角色成功",
	"u038": "编辑角色成功",
	"u039": "删除角色成功",
	"u040": "恢复角色成功",
	"u041": "角色名",
	"u042": "编辑角色",
	"u043": "角色名不能为空，且长度不能低于2",
	"u044": "权限",
	"u045": "区域",
	"u046": "区域查看",
	"u047": "权限设置",
	"u048": "设备",
	"u049": "设备查看",
	"u050": "设备联/脱机",
	"u051": "用户",
	"u052": "用户查看",
	"u053": "规范库查看",
	"u054": "规范库管理",
	"u055": "系统记录查看",
	"u056": "系统记录管理",
	"u057": "系统初始化查看",
	"u058": "系统初始化管理",
	"u059": "实时监控查看",
	"u060": "实时监控操作",
	"u061": "实时监控查看",
	"u062": "实时监控操作",
	"u063": "规范参数查看",
	"u064": "规范参数操作",
	"u065": "生产管理查看",
	"u066": "生产管理操作",
	"u067": "系统参数查看",
	"u068": "系统参数操作",
	"u069": "焊接记录查看",
	"u070": "焊接记录操作",
	"u071": "报警记录查看",
	"u072": "报警记录操作",
	"u073": "修改记录查看",
	"u074": "修改记录操作",
	"u075": "焊点管理查看",
	"u076": "焊点管理操作",
	"u077": "角色查看",
	"u078": "权限设置成功",
	"u079": "确认密码",
	"u080": "两次密码输入不一致，请重新输入！",
	"u081": "注册信息没有权限获取，请先授权。",
	"u082": "注册信息缺失，请先激活。",
	"u083": "注册信息异常，请重新注册。",
	"u084": "当前版本为试用版，要使用该软件请申请激活码。",
	"u085": "激活",
	"u086": "产品激活",
	"u087": "产品序列号",
	"u088": "请将下方的产品序列号或左方的二维码发送给厂商以获取激活码。",
	"u089": "输入激活码",
	"u090": "如有问题，请联系技术支持。",
	"u091": "复制成功。",
	"u092": "复制失败。",
	"u093": "激活产品",
	"u094": "激活查看",
	"u095": "激活操作",
	"u096": "激活设备类型异常",
	"u097": "生成激活码失败",
	"u098": "激活码不正确",
	"u099": "请输入激活码",
	"u100": "产品序列号缺失",
	"u102": "激活码无效！",
	"u103": "写入激活信息失败，请稍候再试",
	"u104": "激活成功，我们将根据您的激活码信息开放相关权限，如有疑问，请与厂商联系。",
	"u105": "修改密码",
	"u106": "旧密码",
	"u107": "新密码",
	"u108": "请输入旧密码",
	"u109": "旧密码不正确",
	"u110": "请输入新密码",
	"u111": "修改密码成功",
	"u112": "修改密码失败",
	"u113": "显示列",
	"u114": "选择要显示的列",
	"u115": "请选择至少显示一列",
	"l001": "控制台",
	"l002": "联机",
	"l003": "全部联机",
	"l004": "全部脱机",
	"l005": "告警",
	"l006": "脱机成功",
	"l007": "联机成功",
	"l008": "脱机失败",
	"l009": "联机失败",
	"l010": "全部折叠",
	"l011": "全部展开",
	"b001": "数据库管理",
	"b002": "规范库",
	"b003": "系统参拷贝",
	"b004": "参数比较",
	"b005": "电流限定参数",
	"b006": "规范号",
	"b007": "规范名称",
	"b008": "焊1最小",
	"b009": "焊1最大",
	"b010": "焊2最小",
	"b011": "焊2最大",
	"b012": "焊3最小",
	"b013": "焊3最大",
	"b014": "功率模式",
	"b015": "混合",
	"b016": "恒流",
	"b017": "占空比",
	"b018": "预压",
	"b019": "追压",
	"b020": "预焊",
	"b021": "冷却",
	"b022": "缓升",
	"b023": "焊1",
	"b024": "冷1",
	"b025": "焊2",
	"b026": "冷2",
	"b027": "焊3",
	"b028": "缓降",
	"b029": "冷却",
	"b030": "后焊",
	"b031": "保持",
	"b032": "休止",
	"b033": "复制",
	"b034": "清零本组",
	"b035": "下载本组规范",
	"b036": "批量下载规范",
	"b037": "焊2脉冲个数",
	"b038": "无配置数据",
	"b039": "获取最大规范值错误",
	"b040": "规范",
	"b041": "添加规范异常，请稍候再重试",
	"b042": "添加规范成功",
	"b043": "修改规范异常，请稍候再重试",
	"b044": "修改规范成功",
	"b045": "删除规范异常，请稍候再重试",
	"b046": "删除规范成功",
	"b047": "规范号重复，请修改后再提交",
	"b048": "获取规范号异常，请稍候再重试",
	"b049": "规范名称不能为空",
	"b050": "复制规范异常，请稍候再重试",
	"b051": "复制规范成功",
	"b052": "请选择要删除的规范",
	"b053": "请选择要清零的规范",
	"b054": "请选择要复制的规范",
	"b055": "删除数据后不可恢复，确定要删除吗？",
	"b056": "全选",
	"b057": "源设备",
	"b058": "目标设备",
	"b059": "下载全部系统参数",
	"b060": "比较",
	"b061": "对比方式",
	"b062": "控制器",
	"b063": "查询规范库数据异常",
	"b064": "操作异常",
	"b065": "参数",
	"b066": "焊1最小电流",
	"b067": "焊1最大电流",
	"b068": "焊2最小电流",
	"b069": "焊2最大电流",
	"b070": "焊3最小电流",
	"b071": "焊3最大电流",
	"b072": "预压时间",
	"b073": "预压压力",
	"b074": "追压时间",
	"b075": "追压压力",
	"b076": "预焊控制选择",
	"b077": "预焊电流",
	"b078": "预焊时间",
	"b079": "[保留]预焊压力 [KN(0-10000)或%(0-100)]",
	"b080": "冷却时间0",
	"b081": "[保留]冷却压力0 (KN或%)",
	"b082": "缓升时间",
	"b083": "焊1控制选择",
	"b084": "焊1电流",
	"b085": "焊1时间",
	"b086": "UIP功能选用0~1",
	"b087": "冷却时间1",
	"b088": "[保留]焊1压力 [KN(0-10000)或%(0-100)]",
	"b089": "焊2控制选择",
	"b090": "焊2电流",
	"b091": "焊2时间",
	"b092": "焊2压力",
	"b093": "冷却时间2",
	"b094": "UIP参考值 %",
	"b095": "焊2脉冲数",
	"b096": "焊3控制选择",
	"b097": "焊3电流",
	"b098": "焊3时间",
	"b099": "UIP 上公差带 %",
	"b100": "缓降时间",
	"b101": "冷却时间3",
	"b102": "UIP上条件公差带",
	"b103": "后焊控制选择",
	"b104": "后焊电流",
	"b105": "后焊时间",
	"b106": "UIP下条件公差带",
	"b107": "保持时间",
	"b108": "UIP下公差带",
	"b109": "休止时间",
	"b110": "休止压力",
	"b111": "功率控制选择（0-2）0:恒流 1:占空比 2:混合",
	"b112": "飞溅识别电阻门限",
	"b113": "控制器1",
	"b114": "控制器2",
	"b115": "规范库1",
	"b116": "规范库2",
	"b117": "下载本组规范",
	"b118": "批量下载规范",
	"b119": "选择设备号：",
	"b120": "下载到下位机第：",
	"b121": "组",
	"b122": "下位机",
	"b123": "从",
	"b124": "到",
	"b125": "下载成功",
	"b126": "设备类型获取错误",
	"b127": "目标设备规范号超出范围(0-{{.a}})",
	"b128": "「{{.a}}」规范号不存在",
	"b129": "下载失败",
	"b130": "范围选择错误",
	"b131": "下载区间不一致({{.a}}~{{.b}})",
	"b132": "用户「{{.a}}」对设备为{{.b}}下载了规范号「{{.c}}」",
	"b133": "用户「{{.a}}」对设备为{{.b}}批量下载了规范号，从「{{.c}}」至「{{.d}}」下载到「{{.e}}」至「{{.f}}」",
	"b134": "请选择源设备和目标设备",
	"b135": "确认操作",
	"b136": "确定要将设备【",
	"b137": "确定要将设备【",
	"b138": "】的系统参数同步到目标设备吗？",
	"b139": "提交数据不是有效的控制器编号",
	"b140": "用户「{{.a}}」复制制系统参数载规范从机器Id:「{{.b}}」,至:「{{.c}}」",
	"b141": "规范号一致，无法比较",
	"b142": "规范号超出范围(0-959)",
	"b143": "规范号超出范围(0-63)",
	"b144": "没找到控制器",
	"b145": "[保留]焊1压力 [KN(0-10000)或%(0-100)]",
	"b146": "[保留]冷却压力2 [KN(0-10000)或%(0-100)]",
	"b147": "[保留]冷却压力3 [KN(0-10000)或%(0-100)]",
	"b148": "[保留]后焊压力 [KN(0-10000)或%(0-100)]",
	"b149": "[保留]保持压力 [KN(0-10000)或%(0-100)]",
	"b150": "同一规范,不允许比较",
	"b151": "{{.a}} 输入错误",
	"b152": "输入校验错误",
	"b153": "从设备同步到离线库",
	"b154": "从离线库同步到设备",
	"b155": "第",
	"b156": "同步",
	"b157": "范围选择错误",
	"b158": "用户「{{.a}}」 对设备id{{.b}}从设备「{{.c}}」同步到离线库规范「{{.d}}」",
	"b159": "同步成功",
	"b160": "同步失败",
	"b161": "用户「{{.a}}」 对设备id「{{.b}}」保存离线库规范:「{{.c}}」",
	"b162": "保存成功",
	"b163": "保存失败",
	"b164": "用户「{{.a}}」 对设备id{{.b}}离线库同步到规范:「{{.c}}」",
	"b165": "导出规范参数",
	"b166": "预焊控制模式",
	"b167": "焊1控制模式",
	"b168": "焊2控制模式",
	"b169": "焊3控制模式",
	"b170": "后焊控制模式",
	"b171": "导入将覆盖原有数据，确定要导入吗？",
	"b172": "此文件不能导入到该设备",
	"b173": "用户「{{.a}}」 对设备id{{.b}}导入规范:「{{.c}}」",
	"b174": "用户「{{.a}}」 对设备id{{.b}}导入离线库规范:「{{.c}}」",
	"b175": "导入完成，共导入{{.a}}条 ",
	"b176": "详情",
	"b177": "请选择要删除的记录",
	"b178": "删除记录失败",
	"b179": "删除记录成功",
	"b180": "您确定要删除所选记录吗？",
	"b181": "确认",
	"b182": "取消",
	"b183": "获取焊接记录数据异常，请稍候再试",
	"b184": "当前使用规范号",
	"b185": "当前工作阶段",
	"b186": "当前阶段运行时间",
	"b187": "记录不存在",
	"b188": "查找失败，没有找到相关的焊接曲线",
	"b189": "获取告警记录数据异常，请稍候再试",
	"b190": "获取修改记录数据异常，请稍候再试",
	"b191": "规范详情",
	"b192": "请点击'下载' 按钮让'清零' 功能生效!",
	"b193": "压力超出范围",
	"b194": "板厚超出范围",
	"b195": "行",
	"b196": "已存在",
	"b197": "有其它任务进行，暂无法处理",
	"b198": "焊点管理 导入操作成功",
	"b199": "焊点管理 导入操作失败",
	"b200": "焊点管理 校验操作成功",
	"b201": "焊点管理 校验操作失败",
	"b202": "焊点管理 清除操作成功",
	"b203": "焊点管理 清除操作失败",
	"b204": "压力超出范围(0-65535)",
	"b205": "板厚超出范围(0-655.35)",
	"b206": "请选择规范!如果没有规范，请新增",
	"b207": "焊点管理 导入操作成功",
	"b208": "焊点管理 导入操作失败",
	"b209": "删除本地焊点数据失败",
	"b210": "无法创建焊点",
	"b211": "start参数缺失!",
	"b212": "start参数只能为整数!",
	"b213": "end参数缺失!",
	"b214": "end参数只能为整数!",
	"b215": "脉宽参考值",
	"b216": "脉宽累加值",
	"b217": "脉宽计数值",
	"b218": "焊点管理 下载操作失败",
	"r001": "设备状态",
	"r002": "工作",
	"r003": "修磨",
	"r004": "焊接",
	"r005": "检查",
	"r006": "试压",
	"r007": "试焊",
	"r008": "报警",
	"r009": "报警记录查看",
	"r010": "IO状态",
	"r011": "焊接波形",
	"r012": "控制器信息",
	"r013": "实时数据",
	"r014": "单件焊点计数",
	"r015": "班产量",
	"r016": "总生产数",
	"r017": "总焊点数",
	"r018": "已步增数",
	"r019": "已修磨数",
	"r020": "母线电压",
	"r021": "当前规范飞溅计数值",
	"r022": "总飞溅计数值",
	"r023": "控制器硬件版本",
	"r024": "控制器软件版本",
	"r025": "CPLD软件版本",
	"r026": "BOOT版本",
	"r027": "电极",
	"r028": "输入",
	"r029": "输出",
	"r030": "启动信号1",
	"r031": "启动信号2",
	"r032": "程序选择1",
	"r033": "程序选择2",
	"r034": "程序选择4",
	"r035": "程序选择8",
	"r036": "程序选择16",
	"r037": "程序选择32",
	"r038": "检查 / 焊接",
	"r039": "报警复位",
	"r040": "工作 / 修磨",
	"r041": "急停",
	"r042": "变压器温度开关",
	"r043": "逆变器温度开关",
	"r044": "水流开关",
	"r045": "气压开关",
	"r046": "焊接允许",
	"r047": "保留",
	"r048": "计数复位",
	"r049": "程序64",
	"r050": "程序128",
	"r051": "程序256",
	"r052": "程序512",
	"r053": "电极修磨确认",
	"r054": "电极更换确认",
	"r055": "保留28",
	"r056": "保留29",
	"r057": "保留30",
	"r058": "保留31",
	"r059": "机器就绪",
	"r060": "气阀1",
	"r061": "气阀2",
	"r062": "气阀3",
	"r063": "气阀4",
	"r064": "焊接完成",
	"r065": "IGBT触发",
	"r066": "焊接请求",
	"r067": "马达输出",
	"r068": "报警输出",
	"r069": "电极修磨",
	"r070": "电极更换",
	"r071": "修磨阀",
	"r072": "动作完成",
	"r073": "保留20",
	"r074": "保留21",
	"r075": "保留22",
	"r076": "保留23",
	"r077": "保留24",
	"r078": "保留25",
	"r079": "保留26",
	"r080": "保留27",
	"r081": "电流",
	"r082": "电压",
	"r083": "电阻",
	"r084": "压力",
	"r085": "采集设置",
	"r086": "设置",
	"r087": "采集电流曲线",
	"r088": "采集电阻曲线",
	"r089": "采集电压曲线",
	"r090": "采集压力曲线",
	"r091": "设置成功",
	"r092": "更新采集曲线失败",
	"r093": "更新采集曲线成功",
	"r094": "未知道操作类型",
	"r095": "设备编号无效",
	"r096": "设备处于脱机状态,不允许操作",
	"r097": "操作成功",
	"r098": "操作失败",
	"r099": "{{.a}} 未知操作",
	"r100": "未找到显示参数数据",
	"r101": "焊接数据",
	"r102": "统计数据",
	"r103": "计数",
	"r104": "查看",
	"r105": "焊接记录编号",
	"r106": "控制器软件版本",
	"r107": "焊点管理 刷新操作成功",
	"r108": "焊点管理 刷新操作失败",
	"r109": "导入将与原有数据合并，确定要导入吗？",
	"r110": "查询焊点信息异常",
	"r111": "在试焊或试压模式下,不允许该操作",
	"r112": "在修磨状模式下,不允许该操作",
	"r113": "功能开发中",
	"r114": "图形支持框选范围进行放大，双击鼠标恢复默认大小",
	"r115": "无法读取系统文件",
	"r116": "新焊点确认",
	"r117": "新焊点选择",
	"s001": "系统记录",
	"s002": "编号",
	"s003": "操作员",
	"s004": "对象编号",
	"s005": "摘要",
	"s006": "操作时间",
	"s007": "刻度化阶段状态",
	"s008": "阶段选择",
	"s009": "使能控制器就绪，开始正常工作",
	"s010": "使能控制器焊接",
	"s011": "上位机I/O口状态",
	"s012": "错误清除命令",
	"s013": "电流PWM输出设置值",
	"s014": "电极压力输出设置值",
	"s015": "母线电压显示值",
	"s016": "初级电流显示值",
	"s017": "次级电流显示值",
	"s018": "电极压力显示值",
	"s019": "焊接计数器复位命令",
	"s020": "Profibus输入口状态字00",
	"s021": "Profibus输入口状态字01",
	"s022": "Profibus输出口状态字00",
	"s023": "Profibus输出口状态字01",
	"s024": "Devicenet输入口状态字00",
	"s025": "Devicenet输入口状态字01",
	"s026": "Devicenet输出口状态字00",
	"s027": "Devicenet输出口状态字00",
	"s028": "点击或拖放文件至此处进行上传",
	"s029": "导入完成",
	"s030": "刷新",
	"s031": "校验",
	"s032": "清除",
	"s033": "新建焊点",
	"s034": "编辑焊点",
	"s035": "预留",
	"s036": "历史报警记录填表地址指针",
	"s037": "报警状态字（0~31）",
	"s038": "预焊压力",
	"s039": "冷却压力0",
	"s040": "缓升压力",
	"s041": "焊1压力",
	"s042": "冷却压力1",
	"s043": "冷却压力2",
	"s044": "焊3压力",
	"s045": "缓降压力",
	"s046": "冷却压力3",
	"s047": "后焊压力",
	"s048": "保持压力",
	"s049": "焊钳1正在生产的车型号,字段00(存储值为ASCII码值)",
	"s050": "焊钳1正在生产的车型号,字段01(存储值为ASCII码值)",
	"s051": "焊钳1正在生产的车型号,字段02(存储值为ASCII码值)",
	"s052": "焊钳1正在生产的车型号,字段03(存储值为ASCII码值)",
	"s053": "焊钳2正在生产的车型号,字段00(存储值为ASCII码值)",
	"s054": "焊钳2正在生产的车型号,字段01(存储值为ASCII码值)",
	"s055": "焊钳2正在生产的车型号,字段02(存储值为ASCII码值)",
	"s056": "焊钳2正在生产的车型号,字段03(存储值为ASCII码值)",
	"s057": "电极压力模式",
	"s058": "启动2功能是否选用",
	"s059": "焊点确认功能选用",
	"s060": "补焊次数",
	"s061": "试压压力",
	"s062": "控制器CPLD软件版本",
	"s063": "通信接口选择",
	"s064": "通信地址",
	"s065": "网络功能",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Device 序列号",
	"s069": "DeviceNet BaudRate",
	"s070": "额定电压",
	"s071": "逆变器个数",
	"s072": "焊接允许功能选用",
	"s073": "变压器匝数比",
	"s074": "变压器效率",
	"s075": "恒流控制模式",
	"s076": "初级电流门限",
	"s077": "IGBT保护告警复位控制",
	"s078": "HMI急停功能选用",
	"s079": "程序组优先选择功能选用",
	"s080": "比例阀功能选用",
	"s081": "控制器脱离HMI脱机运行功能选用",
	"s082": "大张开工作触发模式",
	"s083": "电极修磨确认功能",
	"s084": "挂焊时,焊钳小张开延时启动",
	"s085": "焊钳1Rogowski线圈电流采样值与实际电流值的比例系数",
	"s086": "焊钳2Rogowski线圈电流采样值与实际电流值的比例系数",
	"s087": "焊钳1CT线圈电流采样值与实际电流值的比例系数",
	"s088": "焊钳2CT线圈电流采样值与实际电流值的比例系数",
	"s089": "系统焊钳1支持实际最大电流",
	"s090": "系统焊钳2支持实际最大电流",
	"s091": "系统焊钳1当前功率因数角",
	"s092": "系统焊钳2当前功率因数角",
	"s093": "系统当前焊接触发控制角",
	"s094": "对于悬挂焊控制器断电后电极臂张开状态",
	"s095": "焊接完成信号以及动作完成信号输出模式",
	"s096": "母线电压显示系数，现在不用设置此参数了",
	"s097": "焊钳1最小初级电流PWM输出设置值",
	"s098": "焊钳1一段初级电流PWM输出设置值",
	"s099": "焊钳1二段初级电流PWM输出设置值",
	"s100": "焊钳1三段初级电流PWM输出设置值",
	"s101": "焊钳1四段初级电流PWM输出设置值",
	"s102": "焊钳1五段初级电流PWM输出设置值",
	"s103": "焊钳1六段初级电流PWM输出设置值",
	"s104": "焊钳1最大初级电流PWM输出设置值",
	"s105": "焊钳1初级最小电流采样值",
	"s106": "焊钳1初级一段电流采样值",
	"s107": "焊钳1初级二段电流采样值",
	"s108": "焊钳1初级三段电流采样值",
	"s109": "焊钳1初级四段电流采样值",
	"s110": "焊钳1初级五段电流采样值",
	"s111": "焊钳1初级六段电流采样值",
	"s112": "焊钳1初级最大电流采样值",
	"s113": "焊钳1初级最小电流显示值",
	"s114": "焊钳1初级一段电流显示值",
	"s115": "焊钳1初级二段电流显示值",
	"s116": "焊钳1初级三段电流显示值",
	"s117": "焊钳1初级四段电流显示值",
	"s118": "焊钳1初级五段电流显示值",
	"s119": "焊钳1初级六段电流显示值",
	"s120": "焊钳1初级最大电流显示值",
	"s121": "焊钳1最小次级电流PWM输出设置值",
	"s122": "焊钳1一段次级电流PWM输出设置值",
	"s123": "焊钳1二段次级电流PWM输出设置值",
	"s124": "焊钳1三段次级电流PWM输出设置值",
	"s125": "焊钳1四段次级电流PWM输出设置值",
	"s126": "焊钳1五段次级电流PWM输出设置值",
	"s127": "焊钳1六段次级电流PWM输出设置值",
	"s128": "焊钳1最大次级电流PWM输出设置值",
	"s129": "焊钳1次级最小电流采样值",
	"s130": "焊钳1次级一段电流采样值",
	"s131": "焊钳1次级二段电流采样值",
	"s132": "焊钳1次级三段电流采样值",
	"s133": "焊钳1次级四段电流采样值",
	"s134": "焊钳1次级五段电流采样值",
	"s135": "焊钳1次级六段电流采样值",
	"s136": "焊钳1次级最大电流采样值",
	"s137": "焊钳1次级最小电流显示值",
	"s138": "焊钳1次级一段电流显示值",
	"s139": "焊钳1次级二段电流显示值",
	"s140": "焊钳1次级三段电流显示值",
	"s141": "焊钳1次级四段电流显示值",
	"s142": "焊钳1次级五段电流显示值",
	"s143": "焊钳1次级六段电流显示值",
	"s144": "焊钳1次级最大电流显示值",
	"s145": "焊钳2最小次级电流PWM输出设置值",
	"s146": "焊钳2一段次级电流PWM输出设置值",
	"s147": "焊钳2二段次级电流PWM输出设置值",
	"s148": "焊钳2三段次级电流PWM输出设置值",
	"s149": "焊钳2四段次级电流PWM输出设置值",
	"s150": "焊钳2五段次级电流PWM输出设置值",
	"s151": "焊钳2六段次级电流PWM输出设置值",
	"s152": "焊钳2最大次级电流PWM输出设置值",
	"s153": "焊钳2次级最小电流采样值",
	"s154": "焊钳2次级一段电流采样值",
	"s155": "焊钳2次级二段电流采样值",
	"s156": "焊钳2次级三段电流采样值",
	"s157": "焊钳2次级四段电流采样值",
	"s158": "焊钳2次级五段电流采样值",
	"s159": "焊钳2次级六段电流采样值",
	"s160": "焊钳2次级最大电流采样值",
	"s161": "焊钳2次级最小电流显示值",
	"s162": "焊钳2次级一段电流显示值",
	"s163": "焊钳2次级二段电流显示值",
	"s164": "焊钳2次级三段电流显示值",
	"s165": "焊钳2次级四段电流显示值",
	"s166": "焊钳2次级五段电流显示值",
	"s167": "焊钳2次级六段电流显示值",
	"s168": "焊钳2次级最大电流显示值",
	"s169": "焊钳1电极一段压力输出设定值",
	"s170": "焊钳1电极二段压力输出设定值",
	"s171": "焊钳1电极一段压力显示值实测值",
	"s172": "焊钳1电极二段压力显示值实测值",
	"s173": "焊钳2电极一段压力输出设定值",
	"s174": "焊钳2电极二段压力输出设定值",
	"s175": "焊钳2电极一段压力显示值实测值",
	"s176": "焊钳2电极二段压力显示值实测值",
	"s177": "初级电流校准参数",
	"s178": "次级电流校准参数",
	"s179": "焊接规范选用模式",
	"s180": "焊钳1初级恒流电流微调参数",
	"s181": "焊钳1次级恒流电流微调参数",
	"s182": "焊钳2初级恒流电流微调参数",
	"s183": "焊钳2次级恒流电流微调参数",
	"s184": "B焊钳修模上行压力",
	"s185": "B焊钳修磨压力",
	"s186": "焊钳1工艺焊点控制功能",
	"s187": "焊钳2工艺焊点控制功能",
	"s188": "单件焊点数满足工艺焊点数报警功能选用",
	"s189": "班产量焊点计数报警功能选用",
	"s190": "报警复位后立即计时",
	"s191": "焊钳1当前焊接循环结束判定时间",
	"s192": "焊钳2当前焊接循环结束判定时间",
	"s193": "焊钳1单件焊点数下限设定值",
	"s194": "焊钳2单件焊点数下限设定值",
	"s195": "焊钳1单件焊点数上限设定值",
	"s196": "焊钳2单件焊点数上限设定值",
	"s197": "焊钳1班产量设定值",
	"s198": "焊钳2班产量设定值",
	"s199": "焊钳1单件焊点计数值",
	"s200": "焊钳2单件焊点计数值",
	"s201": "计数器掉电保存报警信息值",
	"s202": "焊钳数配置模式",
	"s203": "焊钳1步增级数设定值",
	"s204": "焊钳2步增级数设定值",
	"s205": "焊钳1修磨次数设定值",
	"s206": "焊钳2修磨次数设定值",
	"s207": "焊钳1修磨预报警焊点设定值",
	"s208": "焊钳2修磨预报警焊点设定值",
	"s209": "焊钳1步增焊点数1",
	"s210": "焊钳1功率补偿1",
	"s211": "焊钳1压力补偿1",
	"s212": "焊钳1步增焊点数2",
	"s213": "焊钳1功率补偿2",
	"s214": "焊钳1压力补偿2",
	"s215": "焊钳1步增焊点数3",
	"s216": "焊钳1功率补偿3",
	"s217": "焊钳1压力补偿3",
	"s218": "焊钳1步增焊点数4",
	"s219": "焊钳1功率补偿4",
	"s220": "焊钳1压力补偿4",
	"s221": "焊钳1步增焊点数5",
	"s222": "焊钳1功率补偿5",
	"s223": "焊钳1压力补偿5",
	"s224": "焊钳1步增焊点数6",
	"s225": "焊钳1功率补偿6",
	"s226": "焊钳1压力补偿6",
	"s227": "焊钳1步增焊点数7",
	"s228": "焊钳1功率补偿7",
	"s229": "焊钳1压力补偿7",
	"s230": "焊钳1步增焊点数8",
	"s231": "焊钳1功率补偿8",
	"s232": "焊钳1压力补偿8",
	"s233": "焊钳1步增焊点数9",
	"s234": "焊钳1功率补偿9",
	"s235": "焊钳1压力补偿9",
	"s236": "焊钳2步增焊点数1",
	"s237": "焊钳2功率补偿1",
	"s238": "焊钳2压力补偿1",
	"s239": "焊钳2步增焊点数2",
	"s240": "焊钳2功率补偿2",
	"s241": "焊钳2压力补偿2",
	"s242": "焊钳2步增焊点数3",
	"s243": "焊钳2功率补偿3",
	"s244": "焊钳2压力补偿3",
	"s245": "焊钳2步增焊点数4",
	"s246": "焊钳2功率补偿4",
	"s247": "焊钳2压力补偿4",
	"s248": "焊钳2步增焊点数5",
	"s249": "焊钳2功率补偿5",
	"s250": "焊钳2压力补偿5",
	"s251": "焊钳2步增焊点数6",
	"s252": "焊钳2功率补偿6",
	"s253": "焊钳2压力补偿6",
	"s254": "焊钳2步增焊点数7",
	"s255": "焊钳2功率补偿7",
	"s256": "焊钳2压力补偿7",
	"s257": "焊钳2步增焊点数8",
	"s258": "焊钳2功率补偿8",
	"s259": "焊钳2压力补偿8",
	"s260": "焊钳2步增焊点数9",
	"s261": "焊钳2功率补偿9",
	"s262": "焊钳2压力补偿9",
	"s263": "焊钳2最小初级电流PWM输出设置值",
	"s264": "焊钳2一段初级电流PWM输出设置值",
	"s265": "焊钳2二段初级电流PWM输出设置值",
	"s266": "焊钳2三段初级电流PWM输出设置值",
	"s267": "焊钳2四段初级电流PWM输出设置值",
	"s268": "焊钳2五段初级电流PWM输出设置值",
	"s269": "焊钳2六段初级电流PWM输出设置值",
	"s270": "焊钳2最大初级电流PWM输出设置值",
	"s271": "焊钳2初级最小电流采样值",
	"s272": "焊钳2初级一段电流采样值",
	"s273": "焊钳2初级二段电流采样值",
	"s274": "焊钳2初级三段电流采样值",
	"s275": "焊钳2初级四段电流采样值",
	"s276": "焊钳2初级五段电流采样值",
	"s277": "焊钳2初级六段电流采样值",
	"s278": "焊钳2初级最大电流采样值",
	"s279": "焊钳2初级最小电流显示值",
	"s280": "焊钳2初级一段电流显示值",
	"s281": "焊钳2初级二段电流显示值",
	"s282": "焊钳2初级三段电流显示值",
	"s283": "焊钳2初级四段电流显示值",
	"s284": "焊钳2初级五段电流显示值",
	"s285": "焊钳2初级六段电流显示值",
	"s286": "焊钳2初级最大电流显示值",
	"s287": "计数器掉电保存报警信息值高16位",
	"s288": "UIR调整功能选用",
	"s289": "UIR调整时焊接时间延长功能选用",
	"s290": "UIR调整起始时间点",
	"s291": "UIR调整电流上升最大百分比",
	"s292": "UIR调整电流下降最大百分比",
	"s293": "UIR调整时间上升最大百分比",
	"s294": "次级电压采样值转换为显示值系数",
	"s295": "UIR监控功能选用",
	"s296": "SDCARD焊接记录功能选用",
	"s297": "SDCARD一个文件中焊接记录个数",
	"s298": "SDCARD一个文件夹中焊接文件个数",
	"s299": "悬挂焊大张开双电控功能",
	"s300": "次级电阻监测 0:关闭  1:打开",
	"s301": "电阻门限参数全局选用 0:关闭  1:打开",
	"s302": "内部偏移地址",
	"s303": "电流校准时母线电压值",
	"s304": "次级电压在位检测",
	"s305": "时间范围",
	"s306": "30天内",
	"s307": "60天内",
	"s308": "90天内",
	"s309": "条曲线",
	"s310": "时间范围异常",
	"s311": "设置活动曲线成功",
	"s312": "所选曲线不是有效值",
	"s313": "曲线编号无效",
	"s314": "无法找到相应曲线，删除失败",
	"s315": "删除失败",
	"s316": "删除成功",
	"s317": "样本太少，不能生成参考曲线",
	"s318": "确定要将当前参考曲线下载到控制器?",
	"s319": "确定要将当前参考曲线保存到规范库?",
	"s320": "未生成参考曲线,不能下载",
	"s321": "规范号无效(0~143)",
	"s322": "曲线数据错误",
	"s323": "参考曲线数据为空,不能保存",
	"s324": "参考曲线处理错误",
	"s325": "保存参考曲线错误",
	"s326": "报警列表",
	"s327": "执行失败",
	"s328": "执行成功",
	"s329": "校验失败",
	"s330": "执行中...",
	"s331": "由于电流门限模式为百分比模式，{{.a}}只能设置为整数，请检查.如已修改并未生效，请重连设备",
	"s332": "当前在调试模式,请先关闭调试再离开",
	"s333": "电流算法调节模式",
	"s334": "快速",
	"s335": "结束点",
	"s336": "系统配置",
	"s337": "设备参数备份/还原并行处理数",
	"s338": "HRC-670保存文件目录",
	"s339": "HRC-670连接端口号",
	"s340": "系统配置查看",
	"s341": "系统配置管理",
	"s342": "保存参数异常，请稍候再试",
	"s343": "获取系统配置异常，请稍候再试",
	"s344": "保存配置成功",
	"s345": "HRC-670保存文件目录不能为空",
	"s346": "HRC-670保存文件目录路径不存在！",
	"s347": "设备参数备份/还原并行处理数必须为正整数",
	"s348": "设备参数备份/还原并行处理数范围需要在(1-8)",
	"s349": "兼容无焊点映射",
	"i001": "数据管理",
	"i002": "清理数据",
	"i003": "焊接记录",
	"i004": "曲线记录",
	"i005": "报警记录",
	"i006": "UIR参考曲线",
	"i007": "规范库数据",
	"i008": "规范缓存数据",
	"i009": "系统缓存数据",
	"i010": "修改记录",
	"i011": "系统记录",
	"i012": "注意：抹掉数据后将永久不可恢复，强烈建议在抹掉数据前先将数据备份！！",
	"i013": "用户「{{.a}}」抹掉 {{.b}} 的数据",
	"i014": "抹除数据成功",
	"i015": "抹除数据失败",
	"i016": "按时间清理",
	"i017": "1个月",
	"i018": "3个月",
	"i019": "6个月",
	"i020": "1年",
	"i021": "清理时间：",
	"i022": "非按时间清理",
	"i023": "用户「{{.a}}」清理了 {{.b}} 的数据,清理范围：",
	"i024": "设备参数自动备份",
	"i025": "设备开启自动备份后，请选择自动备份时间",
	"i026": "滚动保留数据记录",
	"i027": "开启自动清理，请选择要自动清理的记录",
	"i028": "开启自动清理，请选择要自动清理的时间范围",
	"h001": "用户「{{.a}}」更新了规范库「{{.b}}」(规范名: 「{{.c}}」)",
	"h002": "获取系统记录数据异常，请稍候再试",
	"h003": "用户「{{.a}}」新建了规范库「{{.b}}」(规范名: 「{{.c}}」)",
	"h004": "用户「{{.a}}」删除了规范库「{{.b}}」(规范名: 「{{.c}}」)",
	"h005": "用户「{{.a}}」新建了区域「{{.b}}」",
	"h006": "用户「{{.a}}」更新了区域「{{.b}}」",
	"h007": "用户「{{.a}}」删除了区域「{{.b}}」",
	"h008": "用户「{{.a}}」恢复了区域「{{.b}}」",
	"h009": "用户「{{.a}}」新建了设备「{{.b}}」",
	"h010": "用户「{{.a}}」更新了设备「{{.b}}」",
	"h011": "用户「{{.a}}」删除了设备「{{.b}}」",
	"h012": "用户「{{.a}}」恢复了设备「{{.b}}」",
	"h013": "用户「{{.a}}」新建了用户「{{.b}}」",
	"h014": "用户「{{.a}}」更新了用户「{{.b}}」",
	"h015": "用户「{{.a}}」删除了用户「{{.b}}」",
	"h016": "用户「{{.a}}」恢复了用户「{{.b}}」",
	"h017": "因登录密码错误次数超过「{{.a}}」次，帐号 「{{.b}}」 被冻结20分钟",
	"h018": "用户「{{.a}}」登录成功了",
	"h019": "用户「{{.a}}」更新了设备「{{.b}}」的曲线采集设置",
	"h020": "用户「{{.a}}」新建了角色「{{.b}}」",
	"h021": "用户「{{.a}}」更新了角色「{{.b}}」",
	"h022": "用户「{{.a}}」删除了角色「{{.b}}」",
	"h023": "用户「{{.a}}」恢复了角色「{{.b}}」",
	"h024": "用户「{{.a}}」更改了角色「{{.b}}」的权限",
	"k001": "实时监控",
	"k002": "规范参数",
	"k003": "生产管理",
	"k004": "系统参数",
	"k005": "焊接记录",
	"k006": "报警记录",
	"k007": "修改记录",
	"k008": "焊点管理",
	"k009": "设备端",
	"k010": "离线库",
	"k011": "焊钳选择",
	"k012": "飞溅计数值",
	"k013": "飞溅识别门限",
	"k014": "飞溅时间区域门限",
	"k015": "电阻参考值",
	"k016": "焊接电阻最小门限",
	"k017": "焊接电阻最大门限",
	"k018": "规范号无效",
	"k019": "规范「{{.a}}」从设备加载成功",
	"k020": "规范「{{.a}}」从设备加载失败",
	"k021": "规范「{{.a}}」从离线数据库加载成功",
	"k022": "规范「{{.a}}」从离线数据库加载失败",
	"k023": "下载",
	"k024": "设备->库",
	"k025": "导出",
	"k026": "导入",
	"k027": "电极1校准",
	"k028": "电极2校准",
	"k029": "电极3校准",
	"k030": "电极4校准",
	"k031": "电极5校准",
	"k032": "UIR设置",
	"k033": "UIR曲线",
	"k034": "UIP矩形图",
	"k035": "软件升级",
	"k036": "系统参数备份",
	"k037": "焊机配置",
	"k038": "焊机类型",
	"k039": "普通点焊",
	"k040": "机器人点焊",
	"k041": "普通缝焊",
	"k042": "专用缝焊",
	"k043": "悬挂焊",
	"k044": "定制焊",
	"k045": "凸焊",
	"k046": "比亚迪悬挂焊",
	"k047": "焊点确认",
	"k048": "关闭",
	"k049": "开启",
	"k050": "变压器类型",
	"k051": "电极修磨确认",
	"k052": "焊接完成信号",
	"k053": "脉冲式",
	"k054": "电平式",
	"k055": "电流门限模式选择",
	"k056": "绝对值模式",
	"k057": "百分比模式",
	"k058": "UIP报警模式",
	"k059": "提示",
	"k060": "停机",
	"k061": "最小母线电压",
	"k062": "连续焊接模式",
	"k063": "参考母线电压",
	"k064": "恒流控制",
	"k065": "次级恒流",
	"k066": "初级恒流",
	"k067": "最大电极压力",
	"k068": "逆变输出频率",
	"k069": "功能设定",
	"k070": "HMI急停",
	"k071": "比例阀功能",
	"k072": "规范优先",
	"k073": "主机脱离HMI",
	"k074": "初始设置",
	"k075": "刻度化选择",
	"k076": "校准电极压力",
	"k077": "校准初级电流",
	"k078": "校准次级电流",
	"k079": "校准值",
	"k080": "设定值%",
	"k081": "实测值KN",
	"k082": "功能选定",
	"k083": "UIR监控",
	"k084": "时间补偿",
	"k085": "起始时间",
	"k086": "功能参数",
	"k087": "电流调节上限",
	"k088": "电流调节下限",
	"k089": "飞溅时间区域门限",
	"k090": "飞溅识别门限",
	"k091": "时间延长上限",
	"k092": "次级电压系数",
	"k093": "电阻门限参数全局选用",
	"k094": "次级电阻监测",
	"k095": "焊接电阻最小门限",
	"k096": "焊接电阻最大门限",
	"k097": "时间延长上限",
	"k098": "停止记录UIR",
	"k099": "焊点数",
	"k100": "选中曲张",
	"k101": "焊接时间",
	"k102": "焊点号",
	"k103": "删除曲线",
	"k104": "生成参考曲线",
	"k105": "->控制器",
	"k106": "UIP功能选用",
	"k107": "UIP参考值",
	"k108": "UIP上公差带",
	"k109": "UIP下公差带",
	"k110": "控制器升级",
	"k111": "说明：控制器在待机时才能升级，升级过程中请不要断电，升级完成后需重启控制器。",
	"k112": "固件",
	"k113": "请选择升级的固件文件",
	"k114": "选择文件",
	"k115": "升级",
	"k116": "恢复出厂设置",
	"k117": "说明：控制器将恢复出厂设置，原数据将丢失",
	"k118": "选项",
	"k119": "系统参数",
	"k120": "恢复",
	"k121": "校准参数",
	"k122": "次级回路阻抗",
	"k123": "焊接允许",
	"k124": "最大次级电流",
	"k125": "压力输出模式",
	"k126": "最大焊接时间",
	"k127": "脉宽最大变化范围",
	"k128": "正常阻抗",
	"k129": "偏大阻抗",
	"k130": "小阻抗",
	"k131": "IO控制功能",
	"k132": "控制器优先",
	"k133": "RS-485优先",
	"k134": "DeviceNet优先",
	"k135": "MBTCP优先",
	"k136": "ABCC优先",
	"k137": "工作模式优先",
	"k138": "编程器优先",
	"k139": "有效优先",
	"k140": "规范组优先",
	"k141": "UIP设置",
	"k142": "从设备加载成功",
	"k143": "从离线库加载成功",
	"k144": "从设备加载失败",
	"k145": "从离线库加载失败",
	"k146": "次级电压检测",
	"k147": "次级电压检测",
	"k148": "UIR调整",
	"k149": "逆变器频率",
	"k150": "初级电流校准选择",
	"k151": "系统默认",
	"k152": "用户自校准",
	"k153": "逆变器频率",
	"k154": "初级微调系数",
	"k155": "次级电流校准选择",
	"k156": "PWM设定",
	"k157": "实测值(KA)",
	"k158": "采样值",
	"k159": "初级微调系数",
	"k160": "次级微调系数",
	"k161": "次级微调系数",
	"k162": "初级校准值",
	"k163": "次级校准值",
	"k164": "电极压力",
	"k165": "电极初级",
	"k166": "电极次级",
	"k167": "电极1计数器",
	"k168": "电极2计数器",
	"k169": "电极1修磨",
	"k170": "电极2修磨",
	"k171": "工件信息",
	"k172": "生产批号",
	"k173": "操作员",
	"k174": "启动1规范",
	"k175": "启动2规范",
	"k176": "查询",
	"k177": "规范链接级数",
	"k178": "启动延至预压",
	"k179": "功能选择",
	"k180": "步增功能",
	"k181": "功率补偿(%)",
	"k182": "补焊功能",
	"k183": "检查功能",
	"k184": "最大补焊次数",
	"k185": "启动2功能",
	"k186": "单件焊点计数器报警",
	"k187": "班产量计数报警",
	"k188": "报警复位后立即计时",
	"k189": "焊钳工艺焊点控制",
	"k190": "焊钳工艺焊点下限",
	"k191": "焊钳工艺焊点上限",
	"k192": "焊钳焊点结束判定时间（秒）",
	"k193": "单件焊点数",
	"k194": "班产量",
	"k195": "总生产数",
	"k196": "总焊点数",
	"k197": "当前值",
	"k198": "清零",
	"k199": "步增级数",
	"k200": "修磨次数",
	"k201": "修磨预报警",
	"k202": "修磨上行压力",
	"k203": "修磨下行压力",
	"k204": "步增1",
	"k205": "步增2",
	"k206": "步增3",
	"k207": "步增4",
	"k208": "步增5",
	"k209": "步增6",
	"k210": "步增7",
	"k211": "步增8",
	"k212": "步增9",
	"k213": "工件名称",
	"k214": "加载UIP曲线数据错误",
	"k215": "离线获取设置错误",
	"k216": "设备获取设置错误",
	"k217": "焊钳班产量设定值",
	"k218": "设定值",
	"k219": "压力补偿(%)",
	"k220": "请选择日期范围",
	"k221": "日期",
	"k222": "时间",
	"k223": "报警内容",
	"k224": "记录",
	"k225": "创建时间",
	"k226": "车架VIN码",
	"k227": "焊接1(KA/ms)",
	"k228": "焊接2(KA/ms)",
	"k229": "焊接3(KA/ms)",
	"k230": "当前使用焊钳号",
	"k231": "能量(KJ)",
	"k232": "输出脉宽(%)",
	"k233": "次级电压(v)",
	"k234": "次级电阻(μOhm)",
	"k235": "UIP值",
	"k236": "全部",
	"k237": "没报警",
	"k238": "有报警",
	"k239": "修改前",
	"k240": "修改后",
	"k241": "焊点编号",
	"k242": "行号",
	"k243": "压力(N)",
	"k244": "板厚(mm)",
	"k245": "车型",
	"k246": "焊点信息",
	"k247": "板材1材质",
	"k248": "板材1厚度(mm)",
	"k249": "板材2材质",
	"k250": "板材2厚度(mm)",
	"k251": "板材3材质",
	"k252": "板材3厚度(mm)",
	"k253": "板材4材质",
	"k254": "板材4厚度(mm)",
	"k255": "发生",
	"k256": "复位",
	"k257": "内容",
	"k258": "车型号",
	"k259": "焊点映射号",
	"k260": "查询参数异常",
	"k261": "当前设备：",
	"k262": "电极1",
	"k263": "电极2",
	"k264": "库->设备",
	"k265": "离线库未设置，不允许同步",
	"k266": "导出功能异常",
	"k267": "读取规范数据异常",
	"k268": "主键",
	"k269": "零件名称",
	"k270": "预压时间 ms",
	"k271": "追压时间 ms",
	"k272": "预焊电流 KA",
	"k273": "预焊时间 ms",
	"k274": "冷却时间0 ms",
	"k275": "缓升时间 ms",
	"k276": "焊1电流 KA",
	"k277": "焊1时间 ms",
	"k278": "冷却时间1 ms",
	"k279": "焊2电流 KA",
	"k280": "焊2时间 ms",
	"k281": "冷却时间2 ms",
	"k282": "焊3电流 KA",
	"k283": "焊3时间 ms",
	"k284": "缓降时间 ms",
	"k285": "冷却时间3 ms",
	"k286": "后焊电流 KA",
	"k287": "后焊时间 ms",
	"k288": "保持时间 ms",
	"k289": "休止时间 ms",
	"k290": "步增系数",
	"k291": "重复次数",
	"k292": "当前焊点计数",
	"k293": "初级电容电压",
	"k294": "输入口状态（In00~In31）",
	"k295": "输出口状态0（Out00~Out31）",
	"k296": "系统当前工作模式",
	"k297": "焊钳1单件焊点计数值",
	"k298": "焊钳2单件焊点计数值",
	"k299": "焊钳1班产量生产计数值",
	"k300": "焊钳2班产量生产计数值",
	"k301": "焊钳1总生产计数值",
	"k302": "焊钳2总生产计数值",
	"k303": "焊钳1总焊点计数值",
	"k304": "焊钳2总焊点计数值",
	"k305": "焊钳1步增级数计数值",
	"k306": "焊钳2步增级数计数值",
	"k307": "焊钳1修磨次数计数值",
	"k308": "焊钳2修磨次数计数值",
	"k309": "焊钳2当前使用规范号",
	"k310": "历史报警记录条数",
	"k311": "当前使用焊钳号",
	"k312": "能量",
	"k313": "负载能力",
	"k314": "次级电压",
	"k315": "次级电阻",
	"k316": "报警标志",
	"k317": "启动1规范连接级数",
	"k318": "启动延时过预压功能选用",
	"k319": "步增功能选用",
	"k320": "A焊钳修模上行压力",
	"k321": "补焊功能选用",
	"k322": "IO功能选择",
	"k323": "A焊钳修磨压力",
	"k324": "焊钳焊点结束判定时间",
	"k325": "逆变器数",
	"k326": "电流反馈检测",
	"k327": "控制功能优先级设置",
	"k328": "步增级数设定值",
	"k329": "步增级数计数值",
	"k330": "修磨次数设定值",
	"k331": "修磨次数计数值",
	"k332": "修磨预报警焊点设定值",
	"k333": "步增焊点数1",
	"k334": "功率补偿1",
	"k335": "压力补偿1",
	"k336": "步增焊点数2",
	"k337": "功率补偿2",
	"k338": "压力补偿2",
	"k339": "步增焊点数3",
	"k340": "功率补偿3",
	"k341": "压力补偿3",
	"k342": "步增焊点数4",
	"k343": "功率补偿4",
	"k344": "压力补偿4",
	"k345": "步增焊点数5",
	"k346": "功率补偿5",
	"k347": "压力补偿5",
	"k348": "步增焊点数6",
	"k349": "功率补偿6",
	"k350": "压力补偿6",
	"k351": "步增焊点数7",
	"k352": "功率补偿7",
	"k353": "压力补偿7",
	"k354": "步增焊点数8",
	"k355": "功率补偿8",
	"k356": "压力补偿8",
	"k357": "步增焊点数9",
	"k358": "修磨上行压力",
	"k359": "修磨下行压力",
	"k360": "焊钳配置",
	"k361": "焊钳配置模式",
	"k362": "单焊钳",
	"k363": "双焊钳",
	"k364": "多焊钳",
	"k365": "焊钳大张开模式",
	"k366": "保持式",
	"k367": "点动式",
	"k368": "断电时电极臂状态",
	"k369": "小张开",
	"k370": "大张开",
	"k371": "焊钳大张开气阀类型",
	"k372": "单电控",
	"k373": "双电控",
	"k374": "小张开延时启动",
	"k375": "冷却水不足时允许焊接",
	"k376": "焊钳2水流监控功能",
	"k377": "用户「{{.a}}」更新采集曲线设置,设备ID:「{{.b}}」",
	"k378": "用户「{{.a}}」对设备「{{.b}}」下载DIP规范库:「{{.c}}」",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "焊点映射号已存在",
	"k383": "新增焊点成功",
	"k384": "新增焊点失败",
	"k385": "编辑焊点成功",
	"k386": "编辑焊点失败",
	"k387": "保存焊点扩展信息失败",
	"k388": "查询焊点扩展信息失败",
	"k389": "下载失败,设备 {{.a}} 可能脱机",
	"k390": "焊点数无效或大于2000点",
	"k391": "UIR还没开始",
	"k392": "UIR记录已开始，不用重复开始",
	"k393": "开始记录UIR",
	"k394": "停止记录UIR",
	"k395": "查询数据异常",
	"k396": "选中曲线",
	"k397": "生成参考曲线",
	"k398": "->控制器",
	"k399": "->PC",
	"k400": "一包曲线",
	"k401": "加载成功",
	"k402": "没有报警，不需要复位",
	"w001": "焊接1电流超限",
	"w002": "焊接1电流过小",
	"w003": "焊接2电流超限",
	"w004": "焊接2电流过小",
	"w005": "焊接3电流超限",
	"w006": "焊接3电流过小",
	"w007": "IGBT故障",
	"w008": "急停故障",
	"w009": "变压器1温度超限",
	"w010": "中频电源温度超限",
	"w011": "水流开关错误",
	"w012": "气压开关错误",
	"w013": "焊接允许超时",
	"w014": "可编程输入1超时",
	"w015": "可编程输入2超时",
	"w016": "可编程输入3超时",
	"w017": "内存参数表错误",
	"w018": "初级电容充电超时",
	"w019": "系统上电时脚踏开关闭合错误",
	"w020": "初级电容电压过低",
	"w021": "铁电数据写入错误",
	"w022": "预压时间设置错误",
	"w023": "RS485通信故障",
	"w024": "悬挂焊:焊钳2水流开关报警",
	"w025": "光栅保护",
	"w026": "变压器类型设置错误",
	"w027": "恒流模式设置错误",
	"w028": "次级电流档位设置错误",
	"w029": "禁止焊接界面报警",
	"w030": "电流输出保护",
	"w031": "变压器2温度超限",
	"w032": "电流反馈错误",
	"w033": "焊钳1当前焊点数到达单件焊点数设定值",
	"w034": "焊钳1实际焊点数大于单件焊点上限",
	"w035": "焊钳1实际焊点数小于单件焊点下限",
	"w036": "焊钳1班产量到达设定值",
	"w037": "焊钳1修磨预告警",
	"w038": "焊钳1修磨告警",
	"w039": "焊钳1更换告警",
	"w040": "焊钳1更换预告警",
	"w041": "保留01",
	"w042": "焊钳2当前焊点数到达单件焊点数设定值",
	"w043": "焊钳2实际焊点数大于单件焊点上限",
	"w044": "焊钳2实际焊点数小于单件焊点下限",
	"w045": "焊钳2班产量到达设定值\t",
	"w046": "焊钳2修磨预告警",
	"w047": "焊钳2修磨告警",
	"w048": "焊钳2更换告警",
	"w049": "焊钳2更换预告警",
	"w050": "保留49",
	"w051": "保留50",
	"w052": "保留51",
	"w053": "保留52",
	"w054": "保留53",
	"w055": "保留54",
	"w056": "保留55",
	"w057": "保留56",
	"w058": "保留57",
	"w059": "保留58",
	"w060": "保留59",
	"w061": "RTC错误",
	"w062": "SD卡写入错误",
	"w063": "校准参数错误",
	"w164": "递增参数错误",
	"w064": "电流反馈线接触不良",
	"w065": "焊接电阻偏大报警",
	"w066": "焊接电阻偏小报警",
	"w067": "次级电压线缆异常",
	"w168": "UIP偏小",
	"w069": "UIP偏大",
	"w068": "自适应焊接异常",
	"w097": "焊接飞溅报警",
	"w098": "脉宽输出偏大",
	"w099": "UIP偏小",
	"w100": "UIP偏大",
	"z001": "{{.a}}(取值范围「{{.b}}~{{.c}}{{.d}}」) 目标设置值：「{{.e}}」",
	"z002": "不是浮点数:{{.a}}",
	"z003": "不是字符串:{{.a}}",
	"z004": "长度不是{{.a}},长度为{{.b}}",
	"z005": "{{.a}} 此方法控制器没有实现",
	"z006": "脱机",
	"z007": "联机",
	"z008": "异常",
	"z009": "已删除",
	"z010": "{{.a}} 输入错误",
	"z011": "输入校验错误",
	"z012": "报警记录",
	"z013": "调试程序",
	"z014": "数据库管理",
	"z015": "修改记录",
	"z016": "生产管理",
	"z017": "规范参数",
	"z018": "焊接记录",
	"z019": "实时监控",
	"z020": "系统参数",
	"z021": "未激活",
	"z022": "正常",
	"z023": "被冻结",
	"z024": "已删除",
	"z025": "管理员",
	"z026": "操作员",
	"z027": "查看员",
	"z028": "规范号超出范围(0-959)",
	"z029": "规范号超出范围(0-63)",
	"z030": "控制器1不是有效的整数",
	"z031": "控制器2不是有效的整数",
	"z032": "规范号1不是有效的整数",
	"z033": "规范号2不是有效的整数",
	"z034": "同一规范,不允许比较",
	"z035": "工件名称",
	"z036": "生产批号",
	"z037": "操作员",
	"z038": "查询离线规范错误",
	"z039": "不是整数:{{.a}}",
	"z040": "重连中...",
	"g001": "焊钳3总焊点计数值",
	"g002": "焊钳4总焊点计数值",
	"g003": "焊钳5总焊点计数值",
	"g004": "焊钳3步增级数设定值",
	"g005": "焊钳3修磨次数设定值",
	"g006": "焊钳3修磨预报警焊点设定值",
	"g007": "焊钳3步增级数计数值",
	"g008": "焊钳3修磨次数计数值",
	"g009": "焊钳4步增级数设定值",
	"g010": "焊钳4修磨次数设定值",
	"g011": "焊钳4修磨预报警焊点设定值",
	"g012": "焊钳4步增级数计数值",
	"g013": "焊钳4修磨次数计数值",
	"g014": "焊钳5步增级数设定值",
	"g015": "焊钳5修磨次数设定值",
	"g016": "焊钳5修磨预报警焊点设定值",
	"g017": "焊钳5步增级数计数值",
	"g018": "焊钳5修磨次数计数值",
	"g019": "焊钳3步增焊点数1",
	"g020": "焊钳3功率补偿1",
	"g021": "焊钳3压力补偿1",
	"g022": "焊钳3步增焊点数2",
	"g023": "焊钳3功率补偿2",
	"g024": "焊钳3压力补偿2",
	"g025": "焊钳3步增焊点数3",
	"g026": "焊钳3功率补偿3",
	"g027": "焊钳3压力补偿3",
	"g028": "焊钳3步增焊点数4",
	"g029": "焊钳3功率补偿4",
	"g030": "焊钳3压力补偿4",
	"g031": "焊钳3步增焊点数5",
	"g032": "焊钳3功率补偿5",
	"g033": "焊钳3压力补偿5",
	"g034": "焊钳3步增焊点数6",
	"g035": "焊钳3功率补偿6",
	"g036": "焊钳3压力补偿6",
	"g037": "焊钳3步增焊点数7",
	"g038": "焊钳3功率补偿7",
	"g039": "焊钳3压力补偿7",
	"g040": "焊钳3步增焊点数8",
	"g041": "焊钳3功率补偿8",
	"g042": "焊钳3压力补偿8",
	"g043": "焊钳3步增焊点数9",
	"g044": "焊钳3功率补偿9",
	"g045": "焊钳3压力补偿9",
	"g046": "焊钳4步增焊点数1",
	"g047": "焊钳4功率补偿1",
	"g048": "焊钳4压力补偿1",
	"g049": "焊钳4步增焊点数2",
	"g050": "焊钳4功率补偿2",
	"g051": "焊钳4压力补偿2",
	"g052": "焊钳4步增焊点数3",
	"g053": "焊钳4功率补偿3",
	"g054": "焊钳4压力补偿3",
	"g055": "焊钳4步增焊点数4",
	"g056": "焊钳4功率补偿4",
	"g057": "焊钳4压力补偿4",
	"g058": "焊钳4步增焊点数5",
	"g059": "焊钳4功率补偿5",
	"g060": "焊钳4压力补偿5",
	"g061": "焊钳4步增焊点数6",
	"g062": "焊钳4功率补偿6",
	"g063": "焊钳4压力补偿6",
	"g064": "焊钳4步增焊点数7",
	"g065": "焊钳4功率补偿7",
	"g066": "焊钳4压力补偿7",
	"g067": "焊钳4步增焊点数8",
	"g068": "焊钳4功率补偿8",
	"g069": "焊钳4压力补偿8",
	"g070": "焊钳4步增焊点数9",
	"g071": "焊钳4功率补偿9",
	"g072": "焊钳4压力补偿9",
	"g073": "焊钳5步增焊点数1",
	"g074": "焊钳5功率补偿1",
	"g075": "焊钳5压力补偿1",
	"g076": "焊钳5步增焊点数2",
	"g077": "焊钳5功率补偿2",
	"g078": "焊钳5压力补偿2",
	"g079": "焊钳5步增焊点数3",
	"g080": "焊钳5功率补偿3",
	"g081": "焊钳5压力补偿3",
	"g082": "焊钳5步增焊点数4",
	"g083": "焊钳5功率补偿4",
	"g084": "焊钳5压力补偿4",
	"g085": "焊钳5步增焊点数5",
	"g086": "焊钳5功率补偿5",
	"g087": "焊钳5压力补偿5",
	"g088": "焊钳5步增焊点数6",
	"g089": "焊钳5功率补偿6",
	"g090": "焊钳5压力补偿6",
	"g091": "焊钳5步增焊点数7",
	"g092": "焊钳5功率补偿7",
	"g093": "焊钳5压力补偿7",
	"g094": "焊钳5步增焊点数8",
	"g095": "焊钳5功率补偿8",
	"g096": "焊钳5压力补偿8",
	"g097": "焊钳5步增焊点数9",
	"g098": "焊钳5功率补偿9",
	"g099": "焊钳5压力补偿9",
	"g100": "焊钳3次级恒流电流微调参数",
	"g101": "焊钳4初级恒流电流微调参数",
	"g102": "焊钳4次级恒流电流微调参数",
	"g103": "焊钳5初级恒流电流微调参数",
	"g104": "焊钳5次级恒流电流微调参数",
	"g105": "焊钳3最小初级电流PWM输出设置值",
	"g106": "焊钳3一段初级电流PWM输出设置值",
	"g107": "焊钳3二段初级电流PWM输出设置值",
	"g108": "焊钳3三段初级电流PWM输出设置值",
	"g109": "焊钳3四段初级电流PWM输出设置值",
	"g110": "焊钳3五段初级电流PWM输出设置值",
	"g111": "焊钳3六段初级电流PWM输出设置值",
	"g112": "焊钳3最大初级电流PWM输出设置值",
	"g113": "焊钳3初级最小电流采样值",
	"g114": "焊钳3初级一段电流采样值",
	"g115": "焊钳3初级二段电流采样值",
	"g116": "焊钳3初级三段电流采样值",
	"g117": "焊钳3初级四段电流采样值",
	"g118": "焊钳3初级五段电流采样值",
	"g119": "焊钳3初级六段电流采样值",
	"g120": "焊钳3初级最大电流采样值",
	"g121": "焊钳3初级最小电流显示值",
	"g122": "焊钳3初级一段电流显示值",
	"g123": "焊钳3初级二段电流显示值",
	"g124": "焊钳3初级三段电流显示值",
	"g125": "焊钳3初级四段电流显示值",
	"g126": "焊钳3初级五段电流显示值",
	"g127": "焊钳3初级六段电流显示值",
	"g128": "焊钳3初级最大电流显示值",
	"g129": "焊钳3最小次级电流PWM输出设置值",
	"g130": "焊钳3一段次级电流PWM输出设置值",
	"g131": "焊钳3二段次级电流PWM输出设置值",
	"g132": "焊钳3三段次级电流PWM输出设置值",
	"g133": "焊钳3四段次级电流PWM输出设置值",
	"g134": "焊钳3五段次级电流PWM输出设置值",
	"g135": "焊钳3六段次级电流PWM输出设置值",
	"g136": "焊钳3最大次级电流PWM输出设置值",
	"g137": "焊钳3次级最小电流采样值",
	"g138": "焊钳3次级一段电流采样值",
	"g139": "焊钳3次级二段电流采样值",
	"g140": "焊钳3次级三段电流采样值",
	"g141": "焊钳3次级四段电流采样值",
	"g142": "焊钳3次级五段电流采样值",
	"g143": "焊钳3次级六段电流采样值",
	"g144": "焊钳3次级最大电流采样值",
	"g145": "焊钳3次级最小电流显示值",
	"g146": "焊钳3次级一段电流显示值",
	"g147": "焊钳3次级二段电流显示值",
	"g148": "焊钳3次级三段电流显示值",
	"g149": "焊钳3次级四段电流显示值",
	"g150": "焊钳3次级五段电流显示值",
	"g151": "焊钳3次级六段电流显示值",
	"g152": "焊钳3次级最大电流显示值",
	"g153": "焊钳4最小初级电流PWM输出设置值",
	"g154": "焊钳4一段初级电流PWM输出设置值",
	"g155": "焊钳4二段初级电流PWM输出设置值",
	"g156": "焊钳4三段初级电流PWM输出设置值",
	"g157": "焊钳4四段初级电流PWM输出设置值",
	"g158": "焊钳4五段初级电流PWM输出设置值",
	"g159": "焊钳4六段初级电流PWM输出设置值",
	"g160": "焊钳4最大初级电流PWM输出设置值",
	"g161": "焊钳4初级最小电流采样值",
	"g162": "焊钳4初级一段电流采样值",
	"g163": "焊钳4初级二段电流采样值",
	"g164": "焊钳4初级三段电流采样值",
	"g165": "焊钳4初级四段电流采样值",
	"g166": "焊钳4初级五段电流采样值",
	"g167": "焊钳4初级六段电流采样值",
	"g168": "焊钳4初级最大电流采样值",
	"g169": "焊钳4初级最小电流显示值",
	"g170": "焊钳4初级一段电流显示值",
	"g171": "焊钳4初级二段电流显示值",
	"g172": "焊钳4初级三段电流显示值",
	"g173": "焊钳4初级四段电流显示值",
	"g174": "焊钳4初级五段电流显示值",
	"g175": "焊钳4初级六段电流显示值",
	"g176": "焊钳4初级最大电流显示值",
	"g177": "焊钳4最小次级电流PWM输出设置值",
	"g178": "焊钳4一段次级电流PWM输出设置值",
	"g179": "焊钳4二段次级电流PWM输出设置值",
	"g180": "焊钳4三段次级电流PWM输出设置值",
	"g181": "焊钳4四段次级电流PWM输出设置值",
	"g182": "焊钳4五段次级电流PWM输出设置值",
	"g183": "焊钳4六段次级电流PWM输出设置值",
	"g184": "焊钳4最大次级电流PWM输出设置值",
	"g185": "焊钳4次级最小电流采样值",
	"g186": "焊钳4次级一段电流采样值",
	"g187": "焊钳4次级二段电流采样值",
	"g188": "焊钳4次级三段电流采样值",
	"g189": "焊钳4次级四段电流采样值",
	"g190": "焊钳4次级五段电流采样值",
	"g191": "焊钳4次级六段电流采样值",
	"g192": "焊钳4次级最大电流采样值",
	"g193": "焊钳4次级最小电流显示值",
	"g194": "焊钳4次级一段电流显示值",
	"g195": "焊钳4次级二段电流显示值",
	"g196": "焊钳4次级三段电流显示值",
	"g197": "焊钳4次级四段电流显示值",
	"g198": "焊钳4次级五段电流显示值",
	"g199": "焊钳4次级六段电流显示值",
	"g200": "焊钳4次级最大电流显示值",
	"g201": "焊钳5最小初级电流PWM输出设置值",
	"g202": "焊钳5一段初级电流PWM输出设置值",
	"g203": "焊钳5二段初级电流PWM输出设置值",
	"g204": "焊钳5三段初级电流PWM输出设置值",
	"g205": "焊钳5四段初级电流PWM输出设置值",
	"g206": "焊钳5五段初级电流PWM输出设置值",
	"g207": "焊钳5六段初级电流PWM输出设置值",
	"g208": "焊钳5最大初级电流PWM输出设置值",
	"g209": "焊钳5初级最小电流采样值",
	"g210": "焊钳5初级一段电流采样值",
	"g211": "焊钳5初级二段电流采样值",
	"g212": "焊钳5初级三段电流采样值",
	"g213": "焊钳5初级四段电流采样值",
	"g214": "焊钳5初级五段电流采样值",
	"g215": "焊钳5初级六段电流采样值",
	"g216": "焊钳5初级最大电流采样值",
	"g217": "焊钳5初级最小电流显示值",
	"g218": "焊钳5初级一段电流显示值",
	"g219": "焊钳5初级二段电流显示值",
	"g220": "焊钳5初级三段电流显示值",
	"g221": "焊钳5初级四段电流显示值",
	"g222": "焊钳5初级五段电流显示值",
	"g223": "焊钳5初级六段电流显示值",
	"g224": "焊钳5初级最大电流显示值",
	"g225": "焊钳5最小次级电流PWM输出设置值",
	"g226": "焊钳5一段次级电流PWM输出设置值",
	"g227": "焊钳5二段次级电流PWM输出设置值",
	"g228": "焊钳5三段次级电流PWM输出设置值",
	"g229": "焊钳5四段次级电流PWM输出设置值",
	"g230": "焊钳5五段次级电流PWM输出设置值",
	"g231": "焊钳5六段次级电流PWM输出设置值",
	"g232": "焊钳5最大次级电流PWM输出设置值",
	"g233": "焊钳5次级最小电流采样值",
	"g234": "焊钳5次级一段电流采样值",
	"g235": "焊钳5次级二段电流采样值",
	"g236": "焊钳5次级三段电流采样值",
	"g237": "焊钳5次级四段电流采样值",
	"g238": "焊钳5次级五段电流采样值",
	"g239": "焊钳5次级六段电流采样值",
	"g240": "焊钳5次级最大电流采样值",
	"g241": "焊钳5次级最小电流显示值",
	"g242": "焊钳5次级一段电流显示值",
	"g243": "焊钳5次级二段电流显示值",
	"g244": "焊钳5次级三段电流显示值",
	"g245": "焊钳5次级四段电流显示值",
	"g246": "焊钳5次级五段电流显示值",
	"g247": "焊钳5次级六段电流显示值",
	"g248": "焊钳5次级最大电流显示值",
	"g249": "焊钳3初级恒流电流微调参数",
	"g250": "未定义类型: {{.a}}",
	"g251": "焊钳3电极一段压力输出设定值",
	"g252": "焊钳3电极二段压力输出设定值",
	"g253": "焊钳3电极一段压力显示值实测值",
	"g254": "焊钳3电极二段压力显示值实测值",
	"g255": "焊钳4电极一段压力输出设定值",
	"g256": "焊钳4电极二段压力输出设定值",
	"g257": "焊钳4电极一段压力显示值实测值",
	"g258": "焊钳4电极二段压力显示值实测值",
	"g259": "焊钳5电极一段压力输出设定值",
	"g260": "焊钳5电极二段压力输出设定值",
	"g261": "焊钳5电极一段压力显示值实测值",
	"g262": "焊钳5电极二段压力显示值实测值",
	"d001": "刷新数量",
	"d002": "焊点映射号不能为空，且只能为整数",
	"d003": "规范号不能为空，且只能为整数",
	"d004": "压力不能为空，且只能为整数",
	"d005": "板厚不能为空，且只能为小数(取值范围0~99999.99)",
	"d006": "X不能为空，且只能为小数(取值范围0~999999.9999999999)",
	"d007": "Y不能为空，且只能为小数(取值范围0~999999.9999999999)",
	"d008": "Z不能为空，且只能为小数(取值范围0~999999.9999999999)",
	"d009": "板材1厚度只能为小数(取值范围0~99999.99)",
	"d010": "板材2厚度只能为小数(取值范围0~99999.99)",
	"d011": "板材3厚度只能为小数(取值范围0~99999.99)",
	"d012": "板材4厚度只能为小数(取值范围0~99999.99)",
	"d013": "清除数据后不可恢复，确认要清除吗?",
	"d014": "系统参数记录",
	"d015": "焊点管理记录",
	"d016": "操作类型",
	"d017": "新增",
	"d018": "修改",
	"d019": "参数对比",
	"d020": "操作员不存在，无法查询",
	"d021": "设置值缺失或不正常",
	"d022": "导入数量",
	"d023": "计算数量中",
	"d024": "校验数量",
	"d025": "清除数量",
	"d026": "下载数量",
	"d027": "清理数据成功",
	"d028": "清理数据失败",
	"d029": "焊点刷新",
	"d030": "你确认对所选择设备进行焊点刷新操作吗?",
	"d031": "焊点刷新发生异常，无法操作",
	"d032": "焊点刷新已取消",
	"d033": "设备已脱机，无法进行该操作。",
	"d034": "焊点刷新成功",
	"d035": "焊点刷新进度总览",
	"d036": "焊点刷新详情",
	"d037": "焊点刷新进度",
	"d038": "焊点刷新进行中",
	"d039": "焊点刷新失败",
	"d040": "取消焊点刷新后，后续的操作将停止，您确认要取消吗？",
	"d041": "焊点任务已重试。",
	"e001": "飞溅统计",
	"e002": "飞溅统计查看",
	"e003": "飞溅统计管理",
	"e004": "查询维度",
	"e005": "焊点",
	"e006": "查询维度出错",
	"e007": "飞溅计数值",
	"e008": "焊点计数值",
	"e009": "总计数值",
	"e010": "飞溅合格率",
	"e011": "数据视图",
	"e012": "获取车型数据异常",
	"e013": "焊点过滤，多个请以 , 间隔",
	"e014": "规范过滤，多个请以 , 间隔",
	"e015": "单击复制",
	"e016": "序号",
	"e017": "<p>1、可通过选择不同维度查询飞溅率，选择后请点击\"查询\"。</p><p>2、选择区域/设备/车型/焊点/规范后，可再选择左侧列表的各个区域/设备/车型进行查询</p><p>3、选择焊点/规范后，可在搜索栏填入要过滤的焊点/规范再查询（多个时以,间隔）</p>",
	"e018": "工厂",
	"e019": "飞溅记录",
	"e020": "清空查询",
	"e021": "导出完成",
	"e022": "开始导出规范",
	"e023": "正在导出规范",
	"e024": "开始同步",
	"e025": "正在同步",
	"e026": "开始导入规范",
	"e027": "正在导入规范",
	"e028": "写入规范异常",
	"e029": "开始规范号",
	"e030": "结束规范号",
	"e031": "车架VIN码转成流水号",
	"e032": "请输入车架VIN码范围",
	"e033": "车架VIN码需要为整数",
	"e034": "UIP值需为整数，并且大于0",
	"e035": "<p>支持反向过滤报警内容，如\"!焊接1电流超限\"则过滤掉\"焊接1电流超限\"的记录</p>"
}